import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class PrivacyPolicyComponent implements OnInit {
  isLicence: string = 'LI';
  ProductType: any;
  currentYear: any;
  defultTheme: boolean = false;
  constructor(
    private router: Router,
    public dialog: MatDialog,
  ) {
    // let CurrentUser = JSON.parse(localStorage.getItem('currentUser'));
    // if (CurrentUser && CurrentUser?.THEMECOLOUR) {
    //   // this._fuseConfigService.config.colorTheme = CurrentUser.THEMECOLOUR
    // } else {
    //   // this._fuseConfigService.config.colorTheme = 'theme-default'
    // }
    // let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    // this.ProductType = currentUser.PRODUCTTYPE;
    this.currentYear = new Date().getFullYear();
    if (localStorage.getItem('theme_type') == 'theme-yellow-light') this.defultTheme = true;
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    if (this.router.url == '/privacy-policy') {
      setTimeout(() => {
        this.dialog.closeAll();
      }, 50);
    }
  }
}
